import {
	Button,
	Dialog,
	DialogActions,
	DialogContent,
	DialogContentText,
	DialogTitle,
	Typography
} from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";
import { useFreelancerContext } from "../../../../../contexts/useFreelancerContext";
import { useSnackbarContext } from "../../../../../contexts/useSnackBarContext";
import { useFreelancerOnboardingFormSave } from "../../../../../hooks/useFreelancerOnboardingFormsSave";
import { useInvalidMissionEndDateValidation } from "../../../../../hooks/useInvalidMissionEndDateValidation";

const InvalidMissionEndDateDialog: React.FC = () => {
	const { saveOnboardingFormStepAsync, isSaveProgressPending } =
		useFreelancerOnboardingFormSave({
			hideAllSnackbars: true
		});
	const { setCurrentOnboardingFormStep } = useFreelancerContext();
	const { t } = useTranslation();
	const { showError } = useSnackbarContext();
	const {
		showInvalidMissionEndDateDialog,
		nextOnboardingFormStep,
		confirmContinueAnyway,
		cancel
	} = useInvalidMissionEndDateValidation();
	const handleContinue = async () => {
		try {
			await saveOnboardingFormStepAsync(nextOnboardingFormStep!);
		} catch {
			// The save failed: keep the dialog open, and show the feedback here since the
			// save hooks run with hideAllSnackbars.
			showError("freelancerOnboardingFormsProgressUpdate.updateError");
			return;
		}
		confirmContinueAnyway();
		setCurrentOnboardingFormStep(nextOnboardingFormStep!);
	};

	return (
		<Dialog
			open={showInvalidMissionEndDateDialog}
			aria-labelledby="invalid-mission-end-date-dialog-title"
			aria-describedby="invalid-mission-end-date-dialog-description"
			maxWidth="md"
			fullWidth
			slotProps={{
				paper: {
					sx: {
						borderRadius: 2,
						boxShadow: 3
					}
				}
			}}
		>
			<DialogTitle id="invalid-mission-end-date-dialog-title">
				<Typography variant="h3" component="span">
					{t("invalidMissionEndDateDialog.title")}
				</Typography>
			</DialogTitle>
			<DialogContent>
				<DialogContentText id="invalid-mission-end-date-dialog-description">
					{t("invalidMissionEndDateDialog.message")}
				</DialogContentText>
			</DialogContent>
			<DialogActions>
				<Button
					disabled={isSaveProgressPending}
					onClick={cancel}
					color="secondary"
					disableRipple
				>
					{t("invalidMissionEndDateDialog.cancel")}
				</Button>
				<Button
					onClick={handleContinue}
					color="secondary"
					variant="contained"
					disabled={isSaveProgressPending}
					disableRipple
				>
					{isSaveProgressPending
						? t("invalidMissionEndDateDialog.continuing")
						: t("invalidMissionEndDateDialog.continueAnyway")}
				</Button>
			</DialogActions>
		</Dialog>
	);
};

export default InvalidMissionEndDateDialog;
